import { render } from "./rich-textarea.vue?vue&type=template&id=e9ad797e&ts=true"
import script from "./rich-textarea.vue?vue&type=script&lang=ts"
export * from "./rich-textarea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__